import DpInterestPresenter from "@adapters/presenters/Reports/DpInterestReport";
export default (useCases, actions) => {
    return {
        DpInterestReport: new DpInterestPresenter(actions, useCases),
    };
};
